import './styles.scss'
import * as React from 'react'
import { useSelector } from 'react-redux'
import { I18n } from 'react-redux-i18n'
import ReactSwitch from 'react-switch'
import { toast } from 'react-toastify'

import { BrandsAndDelegations, ButtonTag, SelectWithLabel } from 'components/Form'
import { channels as channelsNewApi } from 'api'
import { channelName, chatmailProviders } from 'constants/channels'
import { generateQR, getBotId } from 'utils/helpers'
import ButtonAndLink from './ButtonAndLink'
import { getStaticImage } from 'utils/statics'
import ChannelStatus from './ChannelStatus'
const _ = require('lodash')

const header = [
  { label: 'dashboard_activated', value: 'activated', filter: null },
  { label: 'dashboard_channel', value: 'channel', filter: 'desc' },
  { label: 'dashboard_brand', value: 'brand', filter: null },
  { label: 'dashboard_delegation', value: 'delegation', filter: null },
  { label: 'dashboard_identifier', value: 'botId', filter: null },
  { label: 'dashboard_state', value: 'status', filter: null },
  { label: 'dashboard_share-channel', value: 'share_channel', filter: null },
]

const ChannelList = (props) => {
  const { channels: channelList, getChannels, onEdit, onDelete, pending } = props
  const [ headers, setHeaders ] = React.useState(header)
  const [ channels, setChannels ] = React.useState(channelList)
  const [ copied, setCopied ] = React.useState(false)
  const companies = useSelector( store => store.companies)
  const [ brands, setBrands ] = React.useState([])
  const [ delegations, setDelegations ] = React.useState([])
  const [ channel, setChannel ] = React.useState([])
  const channelOptions = _.filter(_.map(channelName, (value, key) => ({
    label: I18n.t(value.name), value: key, notShow: value.notShow, order: value.order }
  )), (it) => !it.notShow && it.value !== 'wall').sort((a, b) => a.order - b.order)
  const headerOrderDefault = { label: 'dashboard_channel', value: 'channel', filter: 'desc' }
  const [ isOpenModalButtonAndLink, setIsOpenModalButtonAndLink ] = React.useState(false)
  const [ dataToButtonAndLink, setDataToButtonAndLink ] = React.useState(null)

  React.useEffect(()=> {
    setChannels(channelList)
    orderBody(channelList, headerOrderDefault)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [channelList])

  React.useEffect(()=> {
    getChannelsInner(brands, delegations, channel)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [brands, delegations, channel, channelList])

  const orderBy = (_header) => {
    if (_header.value !== 'activated' && _header.value !== 'status' && _header.value !== 'share_channel') {
      _header.filter = _header.filter ? (_header.filter === 'asc' ? 'desc' : 'asc') : 'asc'
      const _headers = _.clone(headers)
      _headers.forEach(it => {
        it.filter = it.value === _header.value ? _header.filter : null
      })

      setHeaders(_headers)
      orderBody(channels, _header)
    }
  }

  const orderBody = (_channelsList = channels, _header) => {
    const _channels = _.cloneDeep(_channelsList )
    if (_header.value === 'channel')
      setChannels(_channels.sort((a, b) => _header.filter === 'asc' ? a.key.localeCompare(b.key) : a.key.localeCompare(b.key)*-1 ))
    else if (_header.value === 'brand')
      setChannels(_channels.sort((a, b) => _header.filter === 'asc' ? a.brandName.localeCompare(b.brandName) : a.brandName.localeCompare(b.brandName)*-1 ))
    else if (_header.value === 'delegation')
      setChannels(_channels.sort((a, b) => _header.filter === 'asc' ? a.delegationName.localeCompare(b.delegationName) : a.delegationName.localeCompare(b.delegationName)*-1 ))
    else if (_header.value === 'botId')
      setChannels(_channels.sort((a, b) => _header.filter === 'asc' ? a.value.botId.localeCompare(b.value.botId) : a.value.botId.localeCompare(b.value.botId)*-1 ))
  }

  const onActive = async (channel, value) => {
    let msg

    try {
      await channelsNewApi.activate(channel._id, value)

      msg = 'dashboard_updated-channel'
    } catch ({ response = {}, message }) {
      const { data = {} } = response

      msg = msg = data?.message?.errorMessage ? data.message.errorMessage : data.type || 'toasts_generic_error'
    }

    toast(I18n.t(msg), { position: 'top-center' })
    getChannels()
  }

  const setLinkCopied = (id, value = I18n.t('channels_link_copied')) => {
    setCopied({ ...copied, [id]: value })
    setTimeout(() => {
      setCopied(copied => ({ ...copied, [id]: false }))
    }, 1500)
  }

  const onChange = (value, type) => {
    if (type === 'brand') {
      setBrands(value[0]?.value ? value : [])
      setDelegations([])
    }
    else if (type === 'delegation') {
      setDelegations(value[0]?.value ? value : [])
    }
    else if (type === 'channel') {
      setChannel(value[0]?.value ? value : [])

    }
  }

  const getChannelsInner = (_brands, _delegations, _channel) => {
    let _channelList = _.clone(channelList)
    if (_brands.length > 0) {
      _channelList = _channelList.filter(it => it.brandDefault === _brands[0]?.value)
    }
    if (_delegations.length > 0) {
      _channelList = _channelList.filter(it => it.delegationDefault === _delegations[0]?.value)
    }
    if (_channel.length > 0) {
      if (_channel[0]?.value === 'chatmail') _channelList = _channelList.filter(it => chatmailProviders.includes(it.key))
      else if (_channel[0]?.value === 'whatsapp_whatsapp') _channelList = _channelList.filter(it => it.hub === 'whatsapp')
      else if (_channel[0]?.value === 'whatsapp') _channelList = _channelList.filter(it => it.key === _channel[0]?.value && it.hub === 'twilio')
      else _channelList = _channelList.filter(it => it.key === _channel[0]?.value || it.value.connectionType === _channel[0]?.value)
    }
    setChannelsAndOrder(_channelList)
  }

  const setChannelsAndOrder = (_channels = channelList) => {
    setChannels(_channels)
  }

  const downloadQR = async (id, url) => {
    setLinkCopied(id, 'Se descargará el QR')
    if (url) {
      const qr = await generateQR(url)
      const a = document.createElement('a')
      a.href = qr
      a.download = 'qr-code.png'
      a.click()
    }
  }

  const setDataToModal = (elem, link) => {
    const _elem = { ...elem, key: chatmailProviders.includes(elem.key) ? 'chatmail' : elem.key }
    setDataToButtonAndLink({ channel: _elem, link: link })
    setIsOpenModalButtonAndLink(true)
  }

  return (
    <>
      <div className='channel-list-selectors'>
        <div className='selectors'>
          <SelectWithLabel
            label={I18n.t('dashboard_channel')}
            name='channel'
            key='channel'
            options={channelOptions}
            multi={false}
            value={channel}
            selectedValues={channel}
            onChange={(value)=>onChange([value], 'channel')}
            placeholder={I18n.t('dashboard_selector_filter-by-channel')}
            classNameWrapper='channel-selector'
            isClearable
            //isOptionDisabled={(option) => {return option.disabled === true}}
          />
          <BrandsAndDelegations
            onChangeBrands={(value)=> onChange([value], 'brand')}
            currentBrands={brands || []}
            onChangeDelegations={(value)=> onChange([value], 'delegation')}
            currentDelegations={delegations || []}
            multi={false}
            labelInside
            displayAllValues={false}
            isClearable
          />
          {/* <i onClick={()=>{
            setChannel([])
            setBrands([])
            setDelegations([])
          }} className='fa fa-repeat qr-reset-filters' /> */}
          <ButtonTag value={I18n.t('dashboard_reset-filters')} className='qr-reset-filters' onClick={()=>{
            setChannel([])
            setBrands([])
            setDelegations([])
          }}/>
        </div>
      </div>
      <div className='channel-list'>
        <div className='header-row'>
          {
            headers.map(elem => (
              <div key={elem.value} className={elem.value}>
                <span onClick={()=>orderBy(elem)}>{I18n.t(elem.label)}</span>
                {elem.filter && (elem.value !== 'activated' && elem.value !== 'share_channel') && <img src='img/icons/icon-expand.svg' alt='expand' className={`${elem.filter}`}/>}
              </div>
            ))
          }
        </div>
        <div className='body-row-list'>
          {channels.length > 0 && channels.map((elem, idx) => {
            const link = elem.url

            const isTyntec = elem.hub === 'tyntec'
            const isInProgress = elem.state === 'IN_PROGRESS'

            return (
              <div
                key={idx}
                className={`body-row animated fadeIn ${isTyntec ? "tyntec_channel" : ''}`}
              >
                <div className='fields'>
                  <ReactSwitch
                    onChange={(value) => {
                      onActive(elem, value)
                    }}
                    checked={elem.isEnabled}
                    onColor='#E87721'
                    uncheckedIcon={false}
                    checkedIcon={false}
                    onHandleColor='#fff'
                    width={50}
                    height={25}
                    className={'activated'}
                    disabled={pending}
                  />
                  <span className='channel-name channel'>
                    {
                      elem.key === 'wall'
                        ? elem.value.connectionType
                          ? I18n.t(channelName[elem.value.connectionType]?.name || '')
                          : I18n.t(channelName[elem.key]?.name || '')
                        : elem.hub === 'whatsapp'
                          ? I18n.t(channelName[`${elem.hub}_${elem.key}`]?.name || '')
                          : I18n.t(channelName[elem.key]?.name || '')
                    }
                    {
                      isTyntec ? ' (Tyntec)' : ''
                    }
                    {
                      elem.isSandbox
                        ? (
                          <span className='channel-sandbox_title'>
                            {I18n.t('channel_sandbox_title')}
                          </span>
                        )
                        : null
                    }
                  </span>
                  <span className='brand'>{elem.brandName}</span>
                  <span className='delegation'>{elem.delegationName}</span>
                  <span className='botId'>{getBotId(elem) || ''}</span>

                  <ChannelStatus
                    channel={elem.key}
                    state={elem.hub === 'chatmail' ? elem?.value?.syncError ? 'SYNC_ERROR' : '' : elem.state}
                    tipId={`channel-status-${idx}`}
                  />

                  {elem.key !== 'wall' && (
                    <div className={'linksToCopy'}>
                      <ButtonTag
                        type={pending ? 'disabled' : 'primary'}
                        value={I18n.t('dashboard_button')}
                        className='share_channel-button'
                        onClick={()=>setDataToModal(elem, link)}
                      />
                      <ButtonTag
                        type={pending ? 'disabled' : 'primary'}
                        value={I18n.t('dashboard_qr')}
                        className='share_channel-qr'
                        onClick={()=>downloadQR(elem._id, link)}
                      />
                    </div>
                  )}
                </div>
                <div className='actions'>
                  <img
                    style={{
                      filter: isInProgress || isTyntec ? 'invert(0.75)' : null,
                      cursor: isInProgress || isTyntec ? 'default' : null
                    }}
                    src={getStaticImage('/icons/orange-brand/icon-edit.svg')}
                    alt='Edit'
                    onClick={() => {
                      if (isTyntec) return null
                      if (isInProgress) return null

                      return onEdit(elem)
                    }}
                  />
                  <img src={getStaticImage('/icons/orange-brand/icon-delete.svg')} alt='Delete' onClick={()=>onDelete(elem)} />
                </div>
              </div>
            )
          })}
        </div>
      </div>
      {dataToButtonAndLink &&
        <ButtonAndLink
          isOpen={isOpenModalButtonAndLink}
          toggle={()=>{setIsOpenModalButtonAndLink(!isOpenModalButtonAndLink); setDataToButtonAndLink(null)}}
          data={dataToButtonAndLink}
          company={companies}
        />
      }
    </>
  )
}

export default ChannelList